import React from "react";
import "./CSS/AboutHero.css";

const AboutHero = () => {
  return (
    <section className="about-hero">
      <div className="about-overlay">
        <div className="about-content">
          <h1>About Us</h1>
          <p>A Curated Selection From Our Stores Across Country</p>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;